import querySelectorAll from './querySelectorAll';

export function offset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
}


export default function initAnchorLinks() {
    const linksToAnchors = querySelectorAll('.js-anchor-link[href^="#"]');

    linksToAnchors.forEach((each) => {
        each.addEventListener('click', (e) => {
            e.preventDefault(); // prevent flicker in Edge and IE11
        });
    });

    // SCROLLSPY
    const scrollspy = document.querySelector('.js-scrollspy');
    const sections = document.querySelectorAll('.js-scrollspy-section');

    if (scrollspy) {
        window.onscroll = () => {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            let currentSection;

            Array.prototype.forEach.call(sections, (section) => {
                if (offset(section).top <= scrollPosition + 1) { // Edge needs the 1 extra  ¯\_(ツ)_/¯
                    currentSection = section;
                }
            });

            if (currentSection && document.querySelector('.js-anchor-link.active')) {
                document.querySelector('.js-anchor-link.active').classList.remove('active');
                document.querySelector(`a[href*=${currentSection.id}]`).classList.add('active');
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/initAnchorlinks.js